import React from 'react';
import Select from 'react-select';
import styles from './style';
export const FilterSelect = ({ options, onChange, placeholder, isMulti, value, }) => {
    return (<Select name="colors" placeholder={placeholder} options={options} className="basic-multi-select" classNamePrefix="select" isMulti={isMulti} menuPortalTarget={document.body} value={value} styles={styles} onChange={onChange}/>);
};
export default FilterSelect;
